import { Fieldset } from '@calendly/form/parts';
import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { AddButton } from 'components/availability/form/add_button';
import { addInterval } from 'components/availability/form/utils';
import WdayRule from 'components/availability/form/wday_rule';
import { useBooleanState } from 'hooks/useBooleanState';
const helpTextIsPhoneCss = "hwbjz1p";
const helpTextCss = "h1l33o9x";
const HelpText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(helpTextCss, {
    [helpTextIsPhoneCss]: isPhone
  }, props.className)}>
      <legend>{I18n.t('publisher.availability.schedules.date_intervals_note')}</legend>
    </Component>;
});
const rulesWrapperCss = "r76a7y7";
const RulesWrapper = forwardRef((props, ref) => <Fieldset ref={ref} {...props} className={classNames(rulesWrapperCss, props.className)} />);
const addIntervalIsTabletUpCss = "a10lx4ka";
const addIntervalCss = "a1p14buv";
const AddInterval = forwardRef((props, ref) => {
  const isTabletUp = useDeviceType('isTabletUp');
  return <AddButton ref={ref} {...props} className={classNames(addIntervalCss, {
    [addIntervalIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
export const IntervalsEditor = ({
  intervals,
  setIntervals
}) => {
  const [autoFocusLast, startAutoFocusLast, stopAutoFocusLast] = useBooleanState(false);
  return <RulesWrapper onBlur={stopAutoFocusLast}>
      <HelpText />
      <WdayRule intervals={intervals} onChange={setIntervals} autoFocusLast={autoFocusLast} />
      <AddInterval title={I18n.t('publisher.availability.schedules.new_interval')} onClick={() => {
      setIntervals(addInterval(intervals));
      startAutoFocusLast();
    }} />
    </RulesWrapper>;
};

require("./intervals_editor.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./intervals_editor.js");